import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { editorTheme } from '../../theme';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.h3`
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${editorTheme.textMuted};
`;

const Section: FC<PropsWithChildren<{ title: string }>> = ({
  title,
  children,
}) => (
  <Wrapper>
    <Label>{title}</Label>
    {children}
  </Wrapper>
);

export const PanelButton = styled.button`
  height: 34px;
  border: 1px solid ${editorTheme.border};
  border-radius: 6px;
  background: ${editorTheme.surface};
  color: ${editorTheme.text};
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover {
    border-color: ${editorTheme.accent};
    color: ${editorTheme.accentHover};
  }
`;

export const ButtonGrid = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  gap: 8px;
`;

export default Section;
